/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS

Last Update:
2nd December 2014
- Added Sidr code

*/

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// Zoom!

$(document).ready(function(){
  
  $('.featured-image-div').zoom();		
  $('a.image-swap').click(function() {
    var newImage = $(this).attr('href');
    $( '.featured-image-div img' ).attr({ src: newImage }); 
    return false;
  });
  
  $('#responsive-menu-button').on('click', function( e ) { 
    e.preventDefault();
    
    if ( $(this).hasClass('active') && $('.mobile-navigation ul.nav-list').length > 0 ) {
		$('.mobile-navigation ul.nav-list')[0].scrollTop = 0;
    }
    
    $(this).toggleClass('active');
    $('.mobile-navigation').toggleClass('active');
  });
  
  $('.mobile-prod-images').flexslider({
    animation: "slide",
    start: function(slider) {
      if ( parseInt($('.mobile-prod-images').find('.slides').attr('data-size')) === 1 ) {
       $('.flex-direction-nav').css('display','none'); 
      }
    }
  });
  
});

// FancyBox

$(document).ready(function() {
	$(".fancybox").fancybox();
});

$(document).ready(function() {
	$(".fancybox-instagram").fancybox({
		padding : 0
	});
});

// Sidr

$(document).ready(function() {
	$('.slide-menu').sidr({
		side: 'right'
	});
});



//remove for updates 2019
// $('#responsive-menu-button').sidr({
// 	name: 'sidr-mobile',
// 	source: '#mobile-navigation',
//   	onOpen: function(){
//   		$('#responsive-menu-button').addClass('active');
//     },
//   	onClose: function(){
//   		$('#responsive-menu-button').removeClass('active');
//     }
// }); 

// Select or Die
